import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';
import { Snackbar, Alert, Typography } from '@mui/material';

export const NotificationContext = createContext({});

export const NotificationProvider = ({ children }) => {
    const [toolbarContent, setToolbarContent] = useState(null);
    const [snackBar, setSnackBar] = useState({ open: false, message: '', severity: 'success', content: null });

    const showSnackbar = useCallback(({ message, severity, content }) => {
        setSnackBar((prev) => ({
            open: true,
            message: message || prev.message,
            severity: severity || prev.severity,
            content: content || null,
        }));
    }, []);

    const handleClose = () => setSnackBar({ ...snackBar, open: false });

    const contextValue = useMemo(() => ({ showSnackbar, toolbarContent, setToolbarContent }), [showSnackbar, toolbarContent]);

    return (
        <NotificationContext.Provider value={contextValue}>
            {children}
            <Snackbar
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                open={snackBar.open}
                autoHideDuration={6000}
                onClose={handleClose}
                // wrap
            >
                <Alert
                    onClose={handleClose}
                    severity={snackBar.severity}
                    sx={{ width: '100%' }}
                    elevation={6}
                    variant="filled"
                    // wrap
                >
                    {snackBar.content ? snackBar.content : <Typography variant="h6">{snackBar.message}</Typography>}
                </Alert>
            </Snackbar>
        </NotificationContext.Provider>
    );
};

export const useNotificationContext = () => {
    const context = useContext(NotificationContext);
    if (context === undefined) {
        throw new Error('useNotificationContext must be used within a NotificationContext');
    }
    return context;
};
